// extracted by mini-css-extract-plugin
export default {"Hero":"Hero_Hero__24HO-","Header":"Hero_Header__nwIAS","Tagline":"Hero_Tagline__yYVIA"};